module.exports = __webpack_public_path__ + "media/icons/linkedIn-a5d4638b.svg";